export const capitalCallNoticeFilename = (purpose: string): string => {
  const token = purpose
    .replace(/[^\p{L}\p{N}._-]+/gu, ' ')
    .trim()
    .replaceAll(/\s+/g, '_');
  return `capital_call_notice_${token}.pdf`;
};
